import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Heading, VStack } from '@library';
import ProductList from '../../ProductList/List/ProductList';
import withErrorBoundary from '../../../../core/components/errors/withErrorBoundary';
import useCurrentStore from '../../../../core/hooks/useCurrentStore';
import SpinnerPage from '../../../../core/components/pages/SpinnerPage';
import PageNotFound from '../../../../core/components/router/PageNotFound';
import useCategory from '../../../../core/queries/useCategory';
import useMetaProduct from '../../../queries/useMetaProduct';
import SparePartsSearchBanner from './SparePartsSearchBanner';

const useSearchParams = () => {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    return {
        searchParams,
    };
};

const CategoryHeader = memo(() => {
    const { categoryId, categoryName } = useCategory();

    return (
        <Heading h3 bold>
            {categoryId ? (
                categoryName
            ) : (
                <FormattedMessage id="all categories" />
            )}
        </Heading>
    );
});

const SparePartsSearchResults = () => {
    const { searchParams } = useSearchParams();
    const { product, loading } = useMetaProduct();
    const { companyCode } = useCurrentStore();

    const isIntercycle = companyCode === 'ic';

    const ignoreList = ['vehicleId', 'bicycleId', 'sparePartParentId'];

    if (loading) {
        return <SpinnerPage />;
    }
    if (!product) {
        return <PageNotFound />;
    }

    return (
        <VStack gap="small">
            <ProductList
                isFiltersLoading={loading}
                ignoreList={ignoreList}
                outerLoading={loading}
                topBanner={<SparePartsSearchBanner product={product} />}
                header={<CategoryHeader />}
                filters={{
                    includeExcludedCategories: false,
                }}
                rootLinks={[
                    {
                        messageId: isIntercycle
                            ? 'bicycle search'
                            : 'spare parts search',
                        to: '/spare-parts',
                    },
                    {
                        text: `${product.manufacturerName} ${product.model}`,
                        to: `/spare-parts-search?${searchParams.toString()}`,
                    },
                ]}
                isSearchResultPage
            />
        </VStack>
    );
};

export default memo(withErrorBoundary(SparePartsSearchResults));
